





















import { Component, Vue } from 'vue-property-decorator'
import MyToolBar from '@/components/Toolbar.vue'
import NavBar from '@/components/NavBar.vue'

@Component({
  name: 'Dashboard',
  components: {
    MyToolBar,
    NavBar
  }
  //   metaInfo() {
  //     return {
  //       title: 'Vuetify Admin Dashboard'
  //     }
  //   }
})
export default class extends Vue {}
